import PartnerOption from "./PartnerOption";
import { useRef } from "react";
import InfiniteList from "ui/common/components/display/InfiniteList/InfiniteList";
import { PartnersListScroll } from "./PartnersList.style";
import usePartnerList from "./hooks/usePartnerList";

export default function PartnersList() {
    const { data, isLoading, fetchNextPage, hasNextPage } = usePartnerList();
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <PartnersListScroll ref={containerRef}>
            <InfiniteList
                container={containerRef}
                data={data}
                end={!hasNextPage}
                isLoading={isLoading}
                renderItem={(partner) => {
                    return !partner.archived && partner.name !== "Apprecio" ? <PartnerOption {...partner} /> : <></>;
                }}
                onEndReached={() => fetchNextPage({ cancelRefetch: false })}
                observerOffset="10px"
            />
        </PartnersListScroll>
    );
}
